import { createAction } from "@reduxjs/toolkit";
export const updateTax = createAction('updateTax');